/**
 * Created by sachinprakash on 12/8/19.
 */
import React, { Suspense } from 'react';
import { Route } from 'react-router';
import { offerAndPrivDiscounts, additionalDiscs } from '../constants/constants';
import GenericSettingContainer from '../containers/GenericSettingContainer/GenericSettingContainer';
import PageLoader from '../components/PageLoader/PageLoader';

const OfferAndPrivDiscSettingsPage = React.lazy(() =>
    import('../pages/DiscountSettingsPages/OfferAndPrivDiscSettingsPage'));
const AdditionalDiscSettingsPage = React.lazy(() =>
    import('../pages/DiscountSettingsPages/AdditionalDiscSettingsPage'));

const DiscountSettingsRoutes = props => (
    <GenericSettingContainer {...props}>
        <Suspense fallback={<PageLoader />}>
            <Route path={offerAndPrivDiscounts} exact component={OfferAndPrivDiscSettingsPage} />
            <Route path={additionalDiscs} exact component={AdditionalDiscSettingsPage} />
        </Suspense>
    </GenericSettingContainer>
);

export default DiscountSettingsRoutes;
